export enum JobPostingSortableField {
  PublishedAt = 'publishedAt',
  CandidateCount = 'candidateCount',
}
